<!-- Menú full‐screen estilo “ART STGO” -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm p-4"
>
  <div
    class="p-6 relative flex w-full max-h-[90%] max-w-xl flex-col overflow-auto rounded-2xl bg-black text-white shadow-xl gap-y-6"
  >
    <!-- 1) Header: Logo + Email + Botón Cerrar Sesión -->
    <div class="flex items-center justify-between px-4 py-3">
      <!-- Logo ART STGO -->
      <div class="flex items-center">
        <img
          src="images/logo/art-stgo-logo-white.png"
          alt="ART STGO"
          class="h-10 w-auto"
        />
      </div>
    </div>

    <!-- Botón de Cerrar Modal -->
    <div
      (click)="closeModal()"
      class="absolute right-4 top-4 p-2 flex items-center rounded-full text-white hover:bg-gray-700 cursor-pointer"
    >
      <mat-icon fontIcon="close"></mat-icon>
    </div>

    <div class="text-sm font-medium">
      {{ datax.user.email }}
    </div>

    <button (click)="logout()" class="action">Cerrar sesión</button>

    <!-- Contenido adicional -->
    <div class="px-8 pb-8 space-y-8">
      <!-- …resto del menú… -->
    </div>
  </div>
</div>
